/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import React, { useCallback } from 'react';

import { LegalEntityProps } from '../../types';

import { LegalEntityFormAction } from './constants';
import { useLegalEntityFormReducer } from './reducer';
import { ActionType, LegalEntityFormActions, LegalEntityStateType } from './types';

interface UseActionsProps extends LegalEntityFormActions {
  state: LegalEntityStateType;
  dispatch: React.Dispatch<ActionType>;
}

export const useActions = (): UseActionsProps => {
  const [state, dispatch] = useLegalEntityFormReducer();

  const setLegalEntity = useCallback(
    (legalEntity: LegalEntityProps): void => {
      dispatch({
        type: LegalEntityFormAction.SET_LEGAL_ENTITY,
        legalEntity: legalEntity,
      });
    },
    [dispatch]
  );

  const setLoadingLegalEntity = useCallback(
    (loading: boolean): void =>
      dispatch({
        type: LegalEntityFormAction.SET_LOADING_LEGAL_ENTITY,
        loading,
      }),
    [dispatch]
  );

  return {
    state,
    dispatch,
    setLegalEntity,
    setLoadingLegalEntity,
  };
};
